// src/components/Minihome/TitleBadge.jsx

import { Box } from "@mui/material";

export default function TitleBadge({
    text,
    style: styleProp = {},
    variant = "pill",
    // ✅ 1. 편집기에서 색상을 직접 받을 수 있도록 props를 추가합니다.
    backgroundColor,
    textColor,
}) {
    const {
        size = "md",
        color = "#111827",
        bg = "rgba(255,255,255,0.6)",
        gradient = null,
        glow = false,
        weight = 700,
        border = false,
        align = "left",
    } = styleProp;

    const fontSize =
        size === "lg" ? "1.25rem" : size === "sm" ? "0.95rem" : "1.05rem";
    const lineHeight = 1.2;

    const textStyle = gradient && gradient.length >= 2
        ? {
            backgroundImage: `linear-gradient(90deg, ${gradient.join(",")})`,
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            color: "transparent",
        }
        // ✅ 3. 그라데이션이 아닐 경우, textColor prop을 우선적으로 사용하도록 수정합니다.
        : { color: textColor || color };

    const shadow = glow
        ? "0 0 10px rgba(255,255,255,0.75), 0 0 20px rgba(255,255,255,0.35)"
        : "none";

    const pillStyle =
        variant === "pill"
            ? {
                // ✅ 2. backgroundColor prop을 우선적으로 사용하도록 수정합니다.
                background: backgroundColor || bg,
                border: border ? "1px solid rgba(0,0,0,0.15)" : "none",
                borderRadius: 9999,
                padding: "6px 12px",
                display: "inline-block",
                backdropFilter: "blur(2px)",
            }
            : {};

    return (
        <Box
            sx={{
                display: "flex",
                justifyContent:
                    align === "center" ? "center" : align === "right" ? "flex-end" : "flex-start",
            }}
        >
            <Box
                sx={{
                    fontWeight: weight,
                    fontSize,
                    lineHeight,
                    textShadow: shadow,
                    ...pillStyle,
                    ...textStyle,
                }}
            >
                {text}
            </Box>
        </Box>
    );
}